import { useContext, useState, useEffect } from "react";
import { PageContext, PageValue } from "../contexts/page";

export default function useStateTypes(webhook) {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    if (webhook.schema.fields) {
      const _types = [];
      const getWebhookTypes = (fields) => {
        Object.keys(fields).forEach((k) => {
          if (fields[k].fields) {
            _types.push({
              name: fields[k].type,
              type: "webhook",
              dispayName: fields[k].name,
              fields: fields[k].fields,
            });
            getWebhookTypes(fields[k].fields);
          }
        });
      };
      getWebhookTypes(webhook.schema.fields);
      setTypes(_types);
    }
  }, [webhook]);

  return types;
}
